import { useState } from "react";
import styled from "styled-components";
import { Font } from "@styles/constants";
import { SmallBodyMediumCSS, XSmallBodyMedium, XSmallBodyRegular } from "@styles/typography";
import { ProductModals } from "@models/product-globals.model";
import { SanitySyncProductDocument } from "@models/product.model";
import PaymentOptionsModal from "./PaymentOptionsModal";

interface TriggerProps {
  product: SanitySyncProductDocument;
  modals?: ProductModals;
  customCopy?: string;
  variantId?: string;
}

const PaymentOptionsTrigger: React.FC<TriggerProps> = ({ product, modals, customCopy = null, variantId = null }) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  return (
    <>
      {customCopy && (
        <LearnMoreCallout onClick={toggleModal} underline>
          {customCopy}
        </LearnMoreCallout>
      )}
      <PaymentOptionsModal
        product={product}
        modals={modals}
        mounted={isModalOpen}
        toggleModal={toggleModal}
        variantId={variantId}
      />
    </>
  );
};

const LearnMoreCallout = styled.button<{ underline?: boolean; as?: string }>`
  ${SmallBodyMediumCSS};
  padding: 0;
  margin: 0;
  white-space: pre-line;
  text-decoration: ${({ underline }) => (underline ? "underline" : "none")};
  cursor: pointer;
`;

export default PaymentOptionsTrigger;
